import { Link, useLocation } from 'react-router-dom';
import { config } from '../../config';

function SearchTabs() {
  const location = useLocation();
  const isFlightsTab = location.pathname.startsWith('/flights');
  const isHotelsTab = location.pathname.startsWith('/hotels');

  return (
    <div className="flex justify-center mb-6">
      <div className="inline-flex bg-black bg-opacity-30 rounded-full p-1">
        <Link
          to="/flights"
          className={`px-8 py-3 text-sm md:text-base rounded-full transition-all duration-200 ${
            isFlightsTab
              ? `bg-white ${config.primaryColorBg}`
              : 'text-white hover:bg-white/10'
          }`}
        >
          ✈️ Flights
        </Link>
        <Link
          to="/hotels"
          className={`px-8 py-3 text-sm md:text-base rounded-full transition-all duration-200 ${
            isHotelsTab
              ? `bg-white ${config.primaryColorBg}`
              : 'text-white hover:bg-white/10'
          }`}
        >
          🏨 Hotels
        </Link>
      </div>
    </div>
  );
}

export default SearchTabs;